import { render, staticRenderFns } from "./BarChartTons.vue?vue&type=template&id=b3a011c4&"
import script from "./BarChartTons.vue?vue&type=script&lang=js&"
export * from "./BarChartTons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports